import { gql } from "@apollo/client";

export const CAMPAIGN_FIELDS_FRAGMENT = gql`
	fragment CampaignFields on Campaign {
		id
		campaignName
		campaignType
		status
		pushNotificationCampaign {
			pushNotifTitle
			pushNotifSubTitle
			pushNotifContent
			pushNotifImage {
				id
				filename
				filepath
				type
				mimetype
				title
				metaData {
					aspectRatio
				}
				uploadedLocs
				imageSizes
			}
			androidNotificationChannel
			data {
				key
				value
			}
		}
		emailCampaign {
			subject
			body
			htmlBody
			attachments
		}
		smsCampaign {
			messageContent
		}
		inAppMessagingCampaign {
			messageTitle
			messageContent
			messageImage
		}
		targetUsers {
			affiliateStatus
			specificAffiliate
			createdDateRange
			learningGoal
			favoriteTopics
			currentStreak
			emailVerified
			excludeNativeLanguage
			hasUsedTrialVersion
			isActive
			isAffiliate
			level
			nativeLanguage
			phoneVerified
			roles
			subscriptionPlans
			studyTimeReminder
			subscriptionExpiryDays
			subscriptionType
			verificationStatus
			userIds
		}
		schedulingSettings {
			endAt
			isStartNow
			recurringTimes
			isCustomCronExpression
			scheduleType
			startAt
		}
		inAppNotificationSettings {
			showInAppNotifications
			notificationGroup
			title
			summary
			relatedPost {
				postId
				contentType
				dynamicGroupId
				storyGroupId
				courseId
				subcourseId
				chapterId
				lessonId
			}
			callToActionLabel
		}
		campaignStats {
			renderedTimes
			sendsNumber
			clicksNumber
			eligiblesNumber
		}
		createdAt
		updatedAt
	}
`;
